export const useCalendarStyles = () => {
    return {
        bookSession: {
          marginTop: '1.5rem',
          marginBottom: '1rem',
          
          width:'100%',
          display:'flex',
          justifyContent:'flex-start'
        },
        bookSessionButton: {
            backgroundColor: '#0b1339',
            textTransform: 'none',
            color: '#fff',
            borderRadius: '2rem',
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            fontSize: '0.8rem',
            '&:hover': {
                backgroundColor: '#0b1339'
              }
        },
        filterButton: {
            backgroundColor: '#0b1339',
            textTransform: 'none',
            color: '#fff',
            borderRadius: '2rem',
            paddingLeft: '2rem',
            paddingRight: '2rem',
            fontSize: '0.8rem',
            '&:hover': {
                backgroundColor: '#0b1339'
              }
        },
        clearButton: {
            backgroundColor: '#fff' ,
            textTransform: 'none',
            color: '#0b1339',
            borderRadius: '2rem',
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            fontSize: '0.8rem',
            border: '1px solid #0b1339'
        },
        sideMenuContainer: {
            overflowY: 'auto',
            overflowX: 'hidden',
            maxWidth: '21rem',
            maxHeight: '92vh',
            height: '100%',
            paddingLeft: '0.8rem',
            paddingRight: '0.8rem',
            backgroundColor: '#fafafa'
        },
        headingContainer: {
            marginTop: '1rem',
            marginBottom: '1rem'
        },
        heading: {
            fontSize: '0.8rem',
            paddingLeft: '0.8rem'
        },
        accordianStyles: {
            fontSize: '0.8rem',
            '&.MuiAccordion-root': { border: 'none' },
            '&.MuiAccordionSummary-root': { margin: 0, padding: 0 },
            '&.MuiAccordionDetails-root': { margin: 0, padding: 0 },
            backgroundColor: '#fafafa',
            boxShadow: 'none',
            minHeight: '20px',
        },
        accordianSummaryStyles: {
            marginTop: '0.1rem',
            marginBottom: '0.1rem',
            '&.MuiAccordionSummary-content': { margin: 0 },
        },
        dateRangeContainer: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '1rem',
            marginTop: '1rem',
        },
        statusSelect: {
            borderRadius: '2rem',
            background: '#fff',
            marginBottom: '1rem',
            border: 'solid 1px #464e5f',
            '.MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
        },
         buttonContainer: {
            display: 'flex',
            justifyContent: 'space-evenly',
            paddingBottom: '1rem'
         }
    }
}